(function () {
  if (window.__adaptiveOverlayTextInit) return;
  window.__adaptiveOverlayTextInit = true;

  var LIGHT_THRESHOLD = 152;

  function sampleLuma(url, done) {
    if (!url) {
      done(null);
      return;
    }

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var canvas = document.createElement('canvas');
        canvas.width = 32;
        canvas.height = 32;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
          done(null);
          return;
        }
        ctx.drawImage(img, 0, 0, 32, 32);
        var data = ctx.getImageData(0, 18, 32, 14).data;
        var sum = 0;
        var n = 0;
        for (var i = 0; i < data.length; i += 4) {
          if (data[i + 3] < 20) continue;
          sum += 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
          n += 1;
        }
        done(n ? sum / n : null);
      } catch (err) {
        done(null);
      }
    };
    img.onerror = function () {
      done(null);
    };
    img.src = url;
  }

  function applyAdaptive(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll
      ? scope.querySelectorAll('[data-adaptive-text]')
      : [];

    if (root && root.hasAttribute && root.hasAttribute('data-adaptive-text')) {
      nodes = [root];
    }

    Array.prototype.forEach.call(nodes, function (el) {
      if (el.getAttribute('data-adaptive-ready') === '1') return;
      el.setAttribute('data-adaptive-ready', '1');
      var url = el.getAttribute('data-adaptive-image');
      sampleLuma(url, function (avg) {
        if (avg == null) return;
        el.classList.toggle('is-light-bg', avg > LIGHT_THRESHOLD);
      });
    });
  }

  applyAdaptive(document);
  document.addEventListener('shopify:section:load', function (event) {
    applyAdaptive(event.target);
  });
})();
